import * as React from "react";

type Props = {
    children: React.ReactNode;
};

type LeftMenuProps = { children: React.ReactNode };
type ContentProps = { children: React.ReactNode };

export default class MainContent extends React.Component<Props> {
    render() {
        return <div className="grid-main-content">{this.props.children}</div>;
    }
}

type HeaderProps = {
    title: React.ReactNode;
    buttons?: React.ReactNode;
};
type ResourcesLayoutProps = {
    id?: string;
    children: React.ReactNode;
};
type ResourcesMainProps = {
    children: React.ReactNode;
};
type SearchProps = {
    children: React.ReactNode;
};

export class ResourcesLayout extends React.Component<ResourcesLayoutProps> {
    static Header = (props: HeaderProps) => {
        return (
            <div className="header">
                <div className="title">{props.title}</div>
                <div className="buttons">{props.buttons}</div>
            </div>
        );
    };

    static List = (props: React.HTMLAttributes<HTMLDivElement> & LeftMenuProps) => {
        return (
            <div {...props} className="resources-layout-list">
                {props.children}
            </div>
        );
    };

    static Content = (props: ContentProps) => {
        return (
            <div {...props} className="resources-layout-content">
                {props.children}
            </div>
        );
    };

    static Main = (props: ResourcesMainProps) => {
        return <div className="resources-layout-main">{props.children}</div>;
    };

    static Search = (props: React.HTMLAttributes<HTMLDivElement> & SearchProps) => {
        return (
            <div {...props} className="search">
                {props.children}
            </div>
        );
    };

    render() {
        const { children, ...rest } = this.props;
        return (
            <div className="resources-layout" {...rest}>
                {children}
            </div>
        );
    }
}
